import Section from "@/components/Section2";
import { LandingEntity } from "@/domain";

export const ThirdSection = ({ info }: { info: LandingEntity }) => {
  return (
    <Section className="mb-16">
      <div className="flex flex-col gap-6 py-8 text-primaryText tablet:py-10 desktop:max-w-xxl desktop:py-16 ">
        <h2
          className="text-title1 tablet:text-header3 desktop:text-header2"
          dangerouslySetInnerHTML={{ __html: info.title }}
        ></h2>

        <div className="flex flex-col gap-6 tablet:gap-10 desktop:flex-row desktop:gap-[5.375rem]">
          <div id="about-third-section" dangerouslySetInnerHTML={{ __html: info.text }}></div>
          <img
            src="/images/about-us-kuber-box-device.png"
            className="w-80 rounded-lg object-cover tablet:w-[336px] desktop:w-[396px]"
          />
        </div>
      </div>
    </Section>
  );
};
